import { render, staticRenderFns } from "./Buddha.vue?vue&type=template&id=0ba8a400&scoped=true"
import script from "./Buddha.vue?vue&type=script&lang=js"
export * from "./Buddha.vue?vue&type=script&lang=js"
import style0 from "./Buddha.vue?vue&type=style&index=0&id=0ba8a400&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8a400",
  null
  
)

export default component.exports